import {Konfigurasjon} from "../infrastruktur/Konfigurasjon";
import {IScope} from "angular";
import {regNavn} from "./tredjepartsTjenestenavn";

/**
 * Hjelpeklasse for tilgang til verdier registrert på root-scope (samt oversikt over hva vi reg. på root-scope),
 * og metoder for reg av eventer på root-scope.
 */
export class RootScopeHjelper {

    static regNavn = "RootScopeHjelper";

    static forInjisering() {
        return [
            regNavn.ng.$rootScope,
            Konfigurasjon.regNavn,
            RootScopeHjelper
        ]
    }

    constructor(private $rootScope: IScope, private konfigurasjon: Konfigurasjon) {
    }

    //offentlige metoder

    public static konfigurasjon_property = "konfigurasjon";
    public static aktivTilstand_property = "aktivTilstand";
    public static ekstraCssBodyKlasse_property = "ekstraCssBodyKlasse";

    /** Gjør konfigurasjonsobjektet tilgjengelig i root-scope under nøkkelen "konfigurasjon" */
    eksponerKonfigurasjon() {
        this.$rootScope[RootScopeHjelper.konfigurasjon_property] = this.konfigurasjon;
    }

    /** Gjør esktra css klasse angitt i url som ekstraCssBodyKlasse parameter i root-scope under nøkkelen "ekstraCssBodyKlasse" */
    eksponerEkstraCssBodyKlasse() {
        var ekstraCssBodyKlasse = /.*ekstraCssBodyKlasse=(\w+)/.exec(window.location.search);
        if (ekstraCssBodyKlasse === null || ekstraCssBodyKlasse.length !== 2) return;
        this.settEkstraCssBodyKlasse(ekstraCssBodyKlasse[1]);
    }

    settEkstraCssBodyKlasse(cssKlasse: string) {
        this.$rootScope[RootScopeHjelper.ekstraCssBodyKlasse_property] = cssKlasse;
    }

    gjeldendeEkstraCssBodyKlasse(): string {
        return this.$rootScope[RootScopeHjelper.ekstraCssBodyKlasse_property] || "";
    }

    lesAktivTilstand() {
        return this.$rootScope[RootScopeHjelper.aktivTilstand_property]
    }

    /**
     * Setter navn på aktiv state i rootScope slik at navnet kan benyttes som css-klasse og dermed i css-selektorer
     */
    eksponerAktivTilstand(aktivState: {name?:string;}) {
        this.$rootScope[RootScopeHjelper.aktivTilstand_property] = `tilstand-${aktivState.name.replace(".", "-")}`;
    }
}

